import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("label", {
  style: {"color":"#ff4949"},
  class: "margin-right5px"
}, "*", -1)
const _hoisted_2 = { class: "popover-text" }
const _hoisted_3 = { class: "popover-text" }
const _hoisted_4 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_question_tip = _resolveComponent("question-tip")
  const _component_cus_option = _resolveComponent("cus-option")
  const _component_cus_select = _resolveComponent("cus-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_dialog_shell = _resolveComponent("dialog-shell")

  return (_openBlock(), _createBlock(_component_dialog_shell, {
    title: _ctx.titles[_ctx.operate],
    onClose: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('close'))),
    onSubmit: _ctx.submit,
    footerType: "customize"
  }, {
    footer: _withCtx(() => [
      _createVNode("span", _hoisted_4, [
        (_ctx.showResetPw)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              onClick: _ctx.resetPw,
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootResetPw), 1)
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_button, {
          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('close')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootCancel), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.submit
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootSubmit), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref: "form",
        "label-position": _ctx.$formLabelPosition,
        model: _ctx.formData,
        rules: _ctx.rules
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode("p", null, [
                _hoisted_1,
                _createTextVNode(" " + _toDisplayString(_ctx.$wordList.ProperAllTextIdentity) + " ", 1),
                _createVNode(_component_question_tip, {
                  placement: "top-start",
                  class: "margin-left10px"
                }, {
                  default: _withCtx(() => [
                    _createVNode("p", _hoisted_2, _toDisplayString(_ctx.$wordList.PeopleIdentityTips), 1)
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_cus_select, {
                modelValue: _ctx.formData.Role,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.Role = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.IdentityOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_cus_option, {
                      key: item.value,
                      value: item.value,
                      label: item.label
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.ProperAllTextFirstName,
            prop: "FirstName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.FirstName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.FirstName = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.ProperAllTextLastName,
            prop: "LastName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.LastName,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.LastName = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.ProperAllTextID,
            prop: "EmployeeID"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.EmployeeID,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.EmployeeID = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.ProperAllTextEmail,
            prop: "Email"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.Email,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.Email = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.AccessibleFloors
          }, {
            default: _withCtx(() => [
              _createVNode(_component_cus_select, {
                multiple: "",
                modelValue: _ctx.formData.Floor,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formData.Floor = $event)),
                onChange: _ctx.changeFloor,
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.floorOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_cus_option, {
                      key: item.key,
                      label: item.value,
                      value: item.key
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ]),
            _: 1
          }, 8, ["label"]),
          (_ctx.operate === 'add')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: _ctx.$wordList.ProperAllTextLanguage
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_cus_select, {
                    modelValue: _ctx.formData.Language,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formData.Language = $event)),
                    filter: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.langOptions, (langItem) => {
                        return (_openBlock(), _createBlock(_component_cus_option, {
                          key: langItem,
                          label: langItem.label,
                          value: langItem.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.ProperAllTextCountryRegion
          }, {
            default: _withCtx(() => [
              _createVNode(_component_cus_select, {
                modelValue: _ctx.formData.PhoneCode,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formData.PhoneCode = $event)),
                filter: "",
                disabled: _ctx.isCNServer ? true : false
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getPhoneCodeOps(), (item) => {
                    return (_openBlock(), _createBlock(_component_cus_option, {
                      key: item,
                      value: item.value,
                      label: item.label
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.ProperAllTextMobileNumber,
            prop: "MobileNumber"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.MobileNumber,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.formData.MobileNumber = $event)),
                onInput: _ctx.limitMobileNumberType
              }, null, 8, ["modelValue", "onInput"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.ProperAllTextSipIpCall
          }, {
            default: _withCtx(() => [
              _createVNode(_component_cus_select, {
                modelValue: _ctx.formData.EnableIpDirect,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.formData.EnableIpDirect = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sipCallOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_cus_option, {
                      key: item,
                      value: item.value,
                      label: item.label
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_checkbox, {
                modelValue: _ctx.formData.HasIntercomAccess,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.formData.HasIntercomAccess = $event)),
                label: _ctx.$wordList.ProperAllTextIntercomAccess,
                disabled: _ctx.operate=='edit'
              }, null, 8, ["modelValue", "label", "disabled"]),
              (_ctx.operate=='add')
                ? (_openBlock(), _createBlock(_component_question_tip, {
                    key: 0,
                    placement: "top-start",
                    class: "margin-left10px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode("p", _hoisted_3, _toDisplayString(_ctx.$wordList.ProperAllTextIntercomTips), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.formData.HasIntercomAccess && _ctx.community.IsEnableLandline.value != 0)
                ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _createVNode("p", null, _toDisplayString(_ctx.$wordList.ProperAllTextLandline), 1),
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.Phone,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.formData.Phone = $event))
                    }, null, 8, ["modelValue"])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: _ctx.$wordList.ProperAllTextCallType
          }, {
            default: _withCtx(() => [
              _createVNode(_component_cus_select, {
                modelValue: _ctx.formData.CallType,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.formData.CallType = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.callTypeOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_cus_option, {
                      key: item,
                      value: item.value,
                      label: item.label
                    }, null, 8, ["value", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["label-position", "model", "rules"])
    ]),
    _: 1
  }, 8, ["title", "onSubmit"]))
}